import {push} from "connected-react-router";
import {saveDesignRequest, getURLforPushInHistory} from "./save-design";
import {
  START,
  AUTO_SAVE_DESIGN,
  SUCCESS,
  FAIL
} from "../constants/action-types";
import Mediator from "../services/Mediator";

let timeoutId;

export const autoSaveDesign = () => {
  return (dispatch, getState) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      if (!Mediator.isDesignSaved) {
        dispatch({
          type: AUTO_SAVE_DESIGN + START
        });
        saveDesignRequest(dispatch, getState)
          .then((response) => {
            // change url
            if (response.product.id) {
              dispatch({
                type: AUTO_SAVE_DESIGN + SUCCESS,
                response
              });
              Mediator.isDesignSaved = true;
              dispatch(push(getURLforPushInHistory(getState())));
            } else {
              throw new Error(`Ошибка сохранения`);
            }
          })
          .catch((error) => {
            dispatch({
              type: AUTO_SAVE_DESIGN + FAIL,
              error
            });
            throw error;
          });
      }
    }, 10000);
  };
};
